module.exports = __webpack_public_path__ + "img/101_Gavriil_Uric_Tetraevanghel_Manastirea_Neamt_1429_e.e4fcef70.png";